module.exports = __webpack_public_path__ + "img/101c341c2dc083bf598189e5bc279eb0.6cd9f5b2.png";